<template>
    <div>
        <el-dialog id="dialog"
                   class="popup"
                   :width="windowWidth > 992 ? (modal ? (modal + 'px') : '800px') : '100%'"
                   :top="windowWidth > 992 ? '80px' : '0'"
                   :append-to-body="true"
                   :destroy-on-close="true"
                   :show-close="false"
                   :before-close="handleClose"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="isAuth"
                   :close-on-press-escape="isAuth"
                   @opened="openPopup"
                   @close="closePopup"
                   @closed="onClosed">
            <button v-if="isAuth" class="btn popup__close" @click.prevent="dialogVisible = false">
                <i class="el-icon-close"></i>
            </button>
            <router-view v-if="dialogVisible"></router-view>
        </el-dialog>

        <el-dialog class="popup popup--scroll"
                   :width="windowWidth > 992 ? '800px' : '100%'"
                   :top="windowWidth > 992 ? '80px' : '0'"
                   :append-to-body="true"
                   :destroy-on-close="true"
                   :show-close="false"
                   :visible.sync="confirmationVisible">
            <div class="popup__header">
                <span class="title title--sm popup__title">{{ $lang('wrapper.title') }}</span>
            </div>

            <div class="popup__content">
                <span class="popup__header-description">{{ $lang('wrapper.description1') }}</span>
                <span class="popup__header-description">{{ $lang('wrapper.description2') }}</span>
                <span class="popup__header-description">{{ $lang('wrapper.description3') }}</span>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg" @click="confirmationVisible = false">{{ $lang('wrapper.button.back') }}</button>
                <button class="btn btn--middle btn--link" @click="closeDialogs()">{{ $lang('wrapper.button.close') }}</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';

    export default {
        name: 'Wrapper',
        data() {
            return {
                dialogVisible: false,
                confirmationVisible: false,
                windowWidth: window.innerWidth,
                laravel: window.laravel,
                scroll: 0,
                isAuth: window.laravel.isAuth
            }
        },
        computed: {
            name() {
                return this.$route.name
            },
            ...mapState('create',[
                'step',
                'type',
                'modal'
            ]),
        },
        watch: {
            name() {
                document.getElementById('dialog').scrollTo(0, 0);
            },
            step() {
                document.getElementById('dialog').scrollTo(0, 0);
            },
            type() {
                document.getElementById('dialog').scrollTo(0, 0);
            }
        },
        methods: {
            ...mapMutations('create', [
                'setStep',
                'setModal'
            ]),
            handleClose() {
                if (this.name === 'free' || this.name === 'pay' || this.name === 'cabinet-create-free' || this.name === 'cabinet-create-pay' || this.name === 'order') {
                    this.confirmationVisible = true;
                } else {
                    this.dialogVisible = false;
                }
            },
            closeDialogs() {
                this.dialogVisible = false;
                this.confirmationVisible = false;
            },
            closePopup() {
                this.setModal(null);

                if (this.scroll > 0) {
                    document.body.style.overflow = 'auto';
                    window.scrollTo(0,this.scroll);
                    document.body.style.removeProperty( 'overflow');
                    this.scroll = 0;
                }
            },
            openPopup() {
                this.setStep(1);

                if (window.innerWidth <= 992) {
                    document.body.style.overflow = 'auto';
                    this.scroll = window.scrollY;
                    window.scrollTo(0,0);
                    document.body.style.removeProperty( 'overflow');
                }
            },
            onClosed() {
                let prefix = window.laravel.prefix;

                if (this.name === 'partner-export-statistic') {
                    return this.$router.push({ name: 'partner-masters' });
                } else if (this.name === 'master-onboarding' || this.name === 'order' ) {
                    return location.href = prefix.length ? prefix : '/';
                } else if (this.laravel.url.length) {
                    let url = this.laravel.url.replace(this.laravel.prefix, '');
                    if (url === '/cabinet/page/add'){
                        return this.$router.push('/cabinet/pages')
                    }

                    return this.$router.push(url.length ? url : '/');
                } else {
                    return location.href = prefix.length ? prefix : '/';
                }
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
            this.dialogVisible = true;
        },
        beforeDestroy() {
            if (this.scroll > 0) {
                document.body.style.overflow = 'auto';
                window.scrollTo(0,this.scroll);
                document.body.style.removeProperty( 'overflow');
                this.scroll = 0;
            }
        }
    }
</script>
